export default function () {
  // When you click on a tab it is shown
  $('.dashboard-tabs a[data-toggle="tab"]').on('click', function (e) {
    e.preventDefault();
    $(this).tab('show');
  });

  // When a tab is fully shown, its name is saved in localStorage as 'selectedTab'
  $('.dashboard-tabs a[data-toggle="tab"]').on('shown.bs.tab', function (e) {
    const id = $(e.target).attr('href');
    localStorage.setItem('selectedTab', id);
  });

  if (localStorage.getItem('selectedTab') == null) {
    $('.dashboard-tabs a[href="#tab_1"]').trigger('click');
  }

  // Create a variable 'selectedTab' with the active tab that was saved in localStorage
  if (localStorage.getItem('selectedTab') != null) {
    const selectedTab = localStorage.getItem('selectedTab');
    // When you enter the dashboard, show the selectedTab saved in localStorage
    if (document.querySelector('.dashboard-tabs')) {
      $(`.dashboard-tabs a[href="${selectedTab}"]`).tab('show');
    }
  }
}
